import { HttpClient } from '#client/http/index'
import {
  ReviewId,
  CreateReviewParams,
  UpdateReviewParams,
  type Review,
} from '#client/resources/index'
import { ApiResponse } from '#client/resources/types'
import { depend } from '#client/utils/depend'
import snakecaseKeys from 'snakecase-keys'

export const get = async (
  { httpClient }: { httpClient: HttpClient },
  id: ReviewId,
): Promise<Review> => {
  const { data }: ApiResponse<Review> = await httpClient.get(
    `/user/reviews/${id}`,
  )
  return data
}

export const create = (
  { httpClient }: { httpClient: HttpClient },
  params: CreateReviewParams,
) => {
  const { timetableId, scores, comment } = params

  return httpClient.post('/user/reviews', {
    timetable_id: timetableId,
    scores: snakecaseKeys(scores),
    comment,
  })
}

export const update = depend(
  { transformScores: snakecaseKeys },
  (
    { transformScores },
    { httpClient }: { httpClient: HttpClient },
    id: ReviewId,
    params: UpdateReviewParams,
  ) => {
    const { timetableId, scores, comment } = params

    return httpClient.put(`/user/reviews/${id}`, {
      timetable_id: timetableId,
      scores: transformScores(scores),
      comment,
    })
  },
)
